var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app", "data-app": "" } },
    [
      _vm.spinnerShown
        ? _c("Spinner", { attrs: { message: "Traitement en cours" } })
        : _vm._e(),
      _vm.estAuthentifie && _vm.etabCourantId ? _c("topbar") : _vm._e(),
      _vm.estAuthentifie && _vm.etabCourantId
        ? _c("div", { staticClass: "app-content content" }, [
            _c("div", { staticClass: "content-wrapper" }, [
              _c(
                "div",
                { staticClass: "content-body" },
                [_c("router-view", { key: _vm.$route.fullPath })],
                1
              )
            ])
          ])
        : _c(
            "div",
            [
              _c(
                "b-modal",
                {
                  attrs: {
                    "no-close-on-backdrop": "",
                    "hide-header": "",
                    "hide-footer": ""
                  },
                  model: {
                    value: _vm.afficherLogin,
                    callback: function($$v) {
                      _vm.afficherLogin = $$v
                    },
                    expression: "afficherLogin"
                  }
                },
                [_c("Login")],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }